import { CustomerSettingsService } from '@/services/api/customerSettingsApiArea/CustomerSettingsService';
import { CustomerSettingsServiceType } from '@/services/api/customerSettingsApiArea/interface';

/** Метод customerSettingsApiArea возвращает экземпляр CustomerSettingsService. По необходимости можно реализовать снгл тон. **/
export const customerSettingsApiArea: { (): CustomerSettingsServiceType } = () =>
  new CustomerSettingsService();
